/**
 * The all-rentals SRP lives at the bare area URL (`/{area}`), not under a slug segment (HP-9411).
 *
 * hotpads-api names it `rentals` and canonicalizes it to `/{area}`. Before it did, `apartments-for-rent`
 * was the slug with no type filter, so saved searches and links from that time still carry it; since
 * HP-9411 step 1 it lists apartments only.
 */
export const ALL_RENTALS_SLUG = 'rentals';
export const INTERIM_ALL_RENTALS_SLUG = 'apartments-for-rent';

const AREA_SEGMENT = /^[a-z0-9]+(?:-[a-z0-9]+)*$/i;

/** A bare one-segment URL can be an area only if it has a resourceId's shape. */
export function hasAreaSegmentShape(segment: string): boolean {
  return AREA_SEGMENT.test(segment);
}

export function isAllRentalsSlug(slug: string | undefined): boolean {
  return slug === ALL_RENTALS_SLUG;
}

/** True for the slug that meant all rentals before the bare area page had its own. */
export function isInterimAllRentalsSlug(slug: string | undefined): boolean {
  return slug === INTERIM_ALL_RENTALS_SLUG;
}
